module.exports = __webpack_public_path__ + "static/media/USDC-DAI.80ea84ac.png";